import React, { useEffect } from 'react';
import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
  Redirect,
} from 'react-router-dom';

import { useAuth } from '../hooks/auth';

import Header from '../components/Header';
import SideBar from '../components/Sidebar';
import { TIPO_USUARIO } from '../utils/funcoes';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  showHeader?: boolean;
  titulo?: string;
  showSideBar?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  showHeader = true,
  titulo,
  showSideBar = false,
  component: Component,

  ...rest
}) => {
  const { user } = useAuth();

  useEffect(() => {
    if (titulo) document.title = titulo;
    window.scrollTo(0, 10);
  }, [titulo]);

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        return isPrivate === !!user ? (
          <>
            {user &&
            user.UsuTipo === TIPO_USUARIO.MEDICO &&
            !location.pathname.toString().match('agendaatendimento') &&
            !location.pathname.toString().match('exame') &&
            !location.pathname.toString().match('pacienteAtendimento') &&
            !location.pathname.toString().match('impressaodocumento') &&
            !location.pathname.toString().match('sair') ? (
              <>
                <Redirect
                  to={{
                    pathname: '/agendaatendimento',
                    state: { from: location },
                  }}
                />
              </>
            ) : (
              <>
                {user &&
                user.UsuTipo === TIPO_USUARIO.COBRANCA &&
                !location.pathname.toString().match('atrasados') &&
                !location.pathname.toString().match('cobrancasrealizadas') &&
                !location.pathname.toString().match('resumocobrancas') &&
                !location.pathname.toString().match('recebimentos31') &&
                !location.pathname.toString().match('recebimentosmes') &&
                !location.pathname.toString().match('cartaosaude') &&
                !location.pathname.toString().match('sair') ? (
                  <>
                    <Redirect
                      to={{
                        pathname: '/atrasados',
                        state: { from: location },
                      }}
                    />
                  </>
                ) : (
                  <>
                    {isPrivate && showHeader && <Header />}
                    {isPrivate && showSideBar ? (
                      <div className="d-flex">
                        <SideBar /> <Component />
                      </div>
                    ) : (
                      <Component />
                    )}
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            {location.pathname.toString().match('painel') ? (
              <Redirect
                to={{
                  pathname: '/painel',
                  state: { from: location },
                }}
              />
            ) : (
              <Redirect
                to={{
                  pathname: isPrivate ? '/' : '/dashboard',
                  state: { from: location },
                }}
              />
            )}
          </>
        );
      }}
    />
  );
};

export default Route;
